import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CostBasisLotsResponse,
  CostBasisMethodResponse,
  CostBasisPosition,
} from '@interfaces/cost-basis/cost-basis.service.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CostBasisService {
  constructor(private http: HttpClient) {}

  costBasisMethodGet(): Observable<CostBasisMethodResponse> {
    return this.http.get<CostBasisMethodResponse>(`secure/cost-basis-method`);
  }

  costBasisMethodPost(
    accountId: string,
    holdings: CostBasisPosition[],
    newCostBasis: string,
  ): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`secure/cost-basis-method`, {
      accountId,
      holdings,
      newCostBasis,
    });
  }

  costBasisLots(accountId: string, holdingId: string): Observable<CostBasisLotsResponse> {
    return this.http.post<CostBasisLotsResponse>(`secure/cost-basis-lots`, {
      accountId,
      holdingId,
    });
  }
}
